import script from "./CustomerDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDetailModal.vue?vue&type=style&index=0&id=edeb6b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edeb6b16"]])

export default __exports__